var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import '@zocdoc/polyfill';
import * as ab_service from './generated/index';
import { callWithTimeout } from './callWithTimeout';
import { increment } from './metrics';
var BASE_PATH = 'https://api-protected.east.zocdoccloud.net';
var ABServiceClient = /** @class */ (function () {
    function ABServiceClient(_a) {
        var projectId = _a.projectId, _b = _a.fetch, fetch = _b === void 0 ? fetchWithRetries : _b, _c = _a.basePath, basePath = _c === void 0 ? BASE_PATH : _c, _d = _a.timeoutInMillis, timeoutInMillis = _d === void 0 ? 1000 : _d, _e = _a.timeoutInMillisForSeoEndpoint, timeoutInMillisForSeoEndpoint = _e === void 0 ? 1500 : _e;
        this.generatedClient = new ab_service.DefaultApi(fetch, basePath);
        this.projectId = projectId;
        this.timeoutInMillis = timeoutInMillis;
        this.timeoutInMillisForSeoEndpoint = timeoutInMillisForSeoEndpoint;
    }
    ABServiceClient.prototype.setAssignmentsWithDefault = function (_a) {
        var attributes = _a.attributes, experiments = _a.experiments, requestOriginUrl = _a.requestOriginUrl, userAgent = _a.userAgent;
        return __awaiter(this, void 0, void 0, function () {
            var error_1, assignments, _i, experiments_1, experiment;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, callWithTimeout(function () {
                                return _this.generatedClient.setAssignments({
                                    assignmentData: {
                                        attributes: attributes,
                                        experiments: experiments,
                                        projectId: _this.projectId,
                                        requestOriginUrl: requestOriginUrl,
                                        userAgent: userAgent,
                                    },
                                });
                            }, this.timeoutInMillis)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        error_1 = _b.sent();
                        increment({
                            name: 'ab_service_client.set_assignments.error',
                            tags: ["status:" + error_1.status],
                        });
                        return [3 /*break*/, 3];
                    case 3:
                        assignments = {};
                        for (_i = 0, experiments_1 = experiments; _i < experiments_1.length; _i++) {
                            experiment = experiments_1[_i];
                            assignments[experiment.experimentId] = experiment.defaultAssignment;
                        }
                        return [2 /*return*/, { assignments: assignments }];
                }
            });
        });
    };
    ABServiceClient.prototype.setAssignmentWithDefault = function (_a) {
        var attributes = _a.attributes, experiment = _a.experiment, requestOriginUrl = _a.requestOriginUrl, userAgent = _a.userAgent;
        return __awaiter(this, void 0, void 0, function () {
            var result, error_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, callWithTimeout(function () {
                                return _this.generatedClient.setAssignments({
                                    assignmentData: {
                                        attributes: attributes,
                                        experiments: [experiment],
                                        projectId: _this.projectId,
                                        requestOriginUrl: requestOriginUrl,
                                        userAgent: userAgent,
                                    },
                                });
                            }, this.timeoutInMillis)];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, {
                                isBot: result.isBot,
                                assignment: result.assignments[experiment.experimentId],
                            }];
                    case 2:
                        error_2 = _b.sent();
                        increment({
                            name: 'ab_service_client.set_assignments.error',
                            tags: ["status:" + error_2.status],
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, { assignment: experiment.defaultAssignment }];
                }
            });
        });
    };
    ABServiceClient.prototype.logAssignments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.logAssignments(params); }, this.timeoutInMillis).catch(function (error) {
                        increment({
                            name: 'ab_service_client.log_assignments.error',
                            tags: ["status:" + error.status],
                        });
                        return Promise.reject(error);
                    })];
            });
        });
    };
    ABServiceClient.prototype.trackConversion = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.trackConversion(params); }, this.timeoutInMillis).catch(function (error) {
                        increment({
                            name: 'ab_service_client.track_conversion.error',
                            tags: ["status:" + error.status],
                        });
                        return Promise.reject(error);
                    })];
            });
        });
    };
    ABServiceClient.prototype.logConversions = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.logConversions(params); }, this.timeoutInMillis).catch(function (error) {
                        increment({
                            name: 'ab_service_client.log_conversions.error',
                            tags: ["status:" + error.status],
                        });
                        return Promise.reject(error);
                    })];
            });
        });
    };
    ABServiceClient.prototype.updateDatafile = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.updateDatafile(params); }, this.timeoutInMillis)];
            });
        });
    };
    ABServiceClient.prototype.getProjectExperiments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.getProjectExperiments(params); }, this.timeoutInMillis)];
            });
        });
    };
    ABServiceClient.prototype.getDatafile = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.getDatafile(params); }, this.timeoutInMillis)];
            });
        });
    };
    ABServiceClient.prototype.getRawDatafile = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () { return _this.generatedClient.getRawDatafile(params); }, this.timeoutInMillis)];
            });
        });
    };
    ABServiceClient.prototype.postLegacyDataFile = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () {
                        return _this.generatedClient.postLegacy({
                            update: params,
                        });
                    }, this.timeoutInMillis)];
            });
        });
    };
    ABServiceClient.prototype.setSEOAssignments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, callWithTimeout(function () {
                        return _this.generatedClient.setSEOAssignments({
                            assignmentData: params,
                        });
                    }, this.timeoutInMillisForSeoEndpoint).catch(function (error) {
                        increment({
                            name: 'ab_service_client.set_seo_assignments.error',
                            tags: ["status:" + error.status],
                        });
                        return Promise.reject(error);
                    })];
            });
        });
    };
    return ABServiceClient;
}());
export { ABServiceClient };
